export default __webpack_public_path__ + "static/media/dropdown.c748675c.png";